import { render, staticRenderFns } from "./EmbeddedAppDelegator.vue?vue&type=template&id=3242168d&scoped=true"
import script from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppDelegator.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppDelegator.vue?vue&type=style&index=0&id=3242168d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3242168d",
  null
  
)

export default component.exports